/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Table_TechnologiesInputs */

const id_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknologi`)
};

const ms_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknologi`)
};

const da_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknologier`)
};

const de_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologien`)
};

const en_us2_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologies`)
};

const es_es2_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologías`)
};

const es_mx2_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologías`)
};

const fil_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Teknolohiya`)
};

const fr_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologies`)
};

const it_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologie`)
};

const hu_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technológiák`)
};

const nl_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologieën`)
};

const no_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknologier`)
};

const pl_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologie`)
};

const pt_br2_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologias`)
};

const pt_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologias`)
};

const ro_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tehnologii`)
};

const fi_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknologiat`)
};

const sv_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknologier`)
};

const vi_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Công nghệ`)
};

const tr_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknolojiler`)
};

const cs_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologie`)
};

const bg_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Технологии`)
};

const ru_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Технологии`)
};

const uk_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Технології`)
};

const ar_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التقنيات`)
};

const hi_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रौद्योगिकियाँ`)
};

const th_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เทคโนโลยี`)
};

const ja_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テクノロジー`)
};

const zh_cn2_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技术栈`)
};

const zh_hant1_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技術棧`)
};

const ko_builds_table_technologies = /** @type {(inputs: Builds_Table_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기술`)
};

/**
* | output |
* | --- |
* | "Technologies" |
*
* @param {Builds_Table_TechnologiesInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_table_technologies = /** @type {((inputs?: Builds_Table_TechnologiesInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Table_TechnologiesInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_table_technologies(inputs)
	if (locale === "ms") return ms_builds_table_technologies(inputs)
	if (locale === "da") return da_builds_table_technologies(inputs)
	if (locale === "de") return de_builds_table_technologies(inputs)
	if (locale === "en-US") return en_us2_builds_table_technologies(inputs)
	if (locale === "es-ES") return es_es2_builds_table_technologies(inputs)
	if (locale === "es-MX") return es_mx2_builds_table_technologies(inputs)
	if (locale === "fil") return fil_builds_table_technologies(inputs)
	if (locale === "fr") return fr_builds_table_technologies(inputs)
	if (locale === "it") return it_builds_table_technologies(inputs)
	if (locale === "hu") return hu_builds_table_technologies(inputs)
	if (locale === "nl") return nl_builds_table_technologies(inputs)
	if (locale === "no") return no_builds_table_technologies(inputs)
	if (locale === "pl") return pl_builds_table_technologies(inputs)
	if (locale === "pt-BR") return pt_br2_builds_table_technologies(inputs)
	if (locale === "pt") return pt_builds_table_technologies(inputs)
	if (locale === "ro") return ro_builds_table_technologies(inputs)
	if (locale === "fi") return fi_builds_table_technologies(inputs)
	if (locale === "sv") return sv_builds_table_technologies(inputs)
	if (locale === "vi") return vi_builds_table_technologies(inputs)
	if (locale === "tr") return tr_builds_table_technologies(inputs)
	if (locale === "cs") return cs_builds_table_technologies(inputs)
	if (locale === "bg") return bg_builds_table_technologies(inputs)
	if (locale === "ru") return ru_builds_table_technologies(inputs)
	if (locale === "uk") return uk_builds_table_technologies(inputs)
	if (locale === "ar") return ar_builds_table_technologies(inputs)
	if (locale === "hi") return hi_builds_table_technologies(inputs)
	if (locale === "th") return th_builds_table_technologies(inputs)
	if (locale === "ja") return ja_builds_table_technologies(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_table_technologies(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_table_technologies(inputs)
	return ko_builds_table_technologies(inputs)
});
export { builds_table_technologies as "builds.table.technologies" }